import React from "react";
import Modal from "react-modal";
import BookPage from './book.js';
import GoodendPage from './goodend.js';
import BadendPage from './badend.js';
import "./modal.scss";

Modal.setAppElement("#root");

const customStyles = {
	overlay: {
		zIndex: "100",
		backgroundColor: "rgba(90, 90, 90, 0.7)",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		padding: "0",
		height:"96%",
		width:"90%",
		maxWidth:"540px",
		transform: "translate(-50%, -50%)",
		backgroundColor: "#17191F",
	}
};

class ModalPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			modalIsOpen: this.props.isOpen,
		};
		this.openModal = this.openModal.bind(this);
		this.afterOpenModal = this.afterOpenModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	openModal() {
		this.setState({modalIsOpen: true});
	}
 
	afterOpenModal() {
		
	}
 
	closeModal() {
		//this.setState({modalIsOpen: false});
		this.props.close();
	}

	render() {
		return (
			<Modal
				isOpen={this.props.isOpen}
				onRequestClose={this.closeModal}
				onAfterOpen={this.afterOpenModal}
				style={customStyles}
				shouldCloseOnOverlayClick={false}
			>
			{this.props.page==="book" &&
				<BookPage
					close={()=>this.closeModal()}
				/>
			}
			{this.props.page==="goodend" &&
				<GoodendPage
					data={this.props.data}
					close={()=>this.closeModal()}
				/>
			}
			{this.props.page==="badend" &&
				<BadendPage
					data={this.props.data}
					close={()=>this.closeModal()}
				/>
			}

			</Modal>
		);
	}
}

export default ModalPage;